import {Component, Inject, inject, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  BaseComponent,
  WmsDialogBodyComponent,
  WmsDialogFooterComponent,
  WmsDialogHeaderComponent, WmsMessageComponent, WmsSpinnerComponent,
} from "@wms/components";
import { WmsWizardComponent } from '../../../components/wms-wizard/wms-wizard.component';
import {camelCase, forEach, get, includes, map, some, toLower, upperFirst, uniqBy} from "lodash-es";
import {replace, triggerFn} from "@wm/core";
import {DialogService, NotificationService, ThemeService} from "@wms/services";
import {ArtifactsService} from "@wms/settings/artifacts";
import {
  ConfigurationComponent
} from "@wms/app/prefab-publish/publish-to-team/screens/configuration/configuration.component";
import {InformationComponent} from "@wms/app/prefab-publish/publish-to-team/screens/information/information.component";
import {SummaryComponent} from "@wms/app/prefab-publish/publish-to-team/screens/summary/summary.component";

const semver = require('semver');

@Component({
  selector: 'wms-publish-artifact-to-team-dialog',
  standalone: true,
  imports: [CommonModule, WmsDialogHeaderComponent, WmsDialogFooterComponent, WmsDialogBodyComponent, WmsSpinnerComponent, WmsWizardComponent, WmsMessageComponent, ConfigurationComponent, InformationComponent, SummaryComponent],
  templateUrl: './publish-artifact-to-team-dialog.component.html',
  styleUrls: ['./publish-artifact-to-team-dialog.component.less']
})
export class PublishArtifactToTeamDialogComponent extends BaseComponent implements OnInit{
  @Input() dialogHeader:string;
  @Input() artifactType:any;
  curStep: any;
  steps: any;
  stepCounter: number;
  nextBtnText: any;
  validatingVersion: boolean;
  processing: boolean;
  isPublishSuccessful: boolean;
  draftAlert: boolean;
  categories: any;
  artifactPublishDetails: any;
  dependencies: any;
  metadataObjs: any;
  projectDetails: any;
  artifactObj: any;
  isNewArtifactObj: any;
  currentThemeObj: any;
  projectObj: any;
  artifactService: ArtifactsService;
  themeService: ThemeService;
  notificationService: NotificationService;
  ARTIFACTS_PUBLISH_DOC_API_URL = '/studio/services/projects/:projectID/prefabDoc';
  documentationUrl: any;
  template: string;
  showErrMsg: boolean;
  errMsg: any = undefined;
  newCategory: any
  teamProjectDetails: any;
  successMessage: any;
  dialogService: DialogService
  showCategoriesList: any
  baseURL = 'assets'
  appBaseMetaInfo: any;
  currentVersion: string;
  suggestedVersions: any[];

  @ViewChild('configurationScreen') configurationScreen : TemplateRef<any>;
  @ViewChild('documentationScreen') documentationScreen : TemplateRef<any>;
  @ViewChild('informationScreen') informationScreen : TemplateRef<any>;
  @ViewChild('summaryScreen') summaryScreen : TemplateRef<any>;


  constructor(@Inject("APP_BUILD_META_INFO") appBaseMetaInfo: any) {
    super();
    this.appBaseMetaInfo = appBaseMetaInfo;
    this.baseURL = this.appBaseMetaInfo.CDN_BASE_URL ? this.appBaseMetaInfo.CDN_BASE_URL + this.baseURL : this.baseURL;
    this.projectDetails = this.projectService.getDetails();
    this.artifactService = inject(ArtifactsService);
    this.themeService = inject(ThemeService);
    this.notificationService = inject(NotificationService);
    this.dialogService = inject(DialogService);
  }

  ngOnInit() {


    this.steps = [
      {
        "label": this.locale.LABEL_ARTIFACT_PUBLISH_INFO,
        "id": "artifact-publish-info",
        "screen": "artifactPublishInfoPartial",
        "description": ''//update this lazily after getting theme details in case of theme prefab or else use project name
      },
      {
        "label": this.locale.LABEL_CONFIG,
        "id": "artifact-config",
        "screen": "artifactConfigPartial",
        "description": replace(this.locale.LABEL_CONFIG_DESCRIPTION, [this.artifactType])
      },
      {
        "label": this.locale.LABEL_ARTIFACT_SUMMARY,
        "id": "artifact-summary",
        "screen": "artifactSummaryPartial",
        "description": this.locale.LABEL_ARTIFACT_SUMMARY_DESCRIPTION
      }
    ];
    this.stepCounter = 0;
    this.curStep = this.steps[this.stepCounter];
    this.nextBtnText = this.locale.LABEL_NEXT;
    this.processing = false;
    this.isNewArtifactObj = false;
    this.draftAlert = false;
    this.isPublishSuccessful = false;
    this.showErrMsg = false;
    this.artifactObj = {};
    this.currentThemeObj = {};
    this.projectObj = {};
    this.artifactPublishDetails = {};
    this.metadataObjs = [];
    this.categories = [];
    this.suggestedVersions = [];
    this.newCategory = "";
    this.dependencies = [];

    this.onStepChange(this.stepCounter);

  }

  decrementStep() {
    this.stepCounter -= 1;
    this.curStep = this.steps[this.stepCounter];
    this.onStepChange(this.stepCounter, true);

  }

  onStepChange(stepCount: any, isDecrement?: any) {
    this.onNextStep(stepCount);
  }

  onNextStep(step: number) {
    this.updateNextBtnText();
    this.template = this.steps[step].screen
    switch (step) {
      case 0:
        //calling artifact details on success of categories call. We need to do this as we are allowing the categories to be deleted.
        //if the deleted category(can check in the categories list) is present the artifact details obj.
        //we need to hide the deleted category and ask the user for new category.
        this.getArtifactCategories();
        this.setDependencies();
        break;
      case 1:
        this.getMetadata();
        break;
      case 2:
        this.showDocumentation();
        break;
      case 3:
        break;
      default:
        break;
    }

  }

  showDocumentation() {
    this.documentationUrl = this.ARTIFACTS_PUBLISH_DOC_API_URL.replace(/\:projectID/ig, this.projectDetails.id);
    //to avoid caching. adding random url param
    this.documentationUrl = this.documentationUrl + "?d=" + new Date().getTime();
  }


  getMetadata() {
    if (!this.metadataObjs.length) {
      this.artifactService.getSystemMetadata().then((metadataObjs) => {
        metadataObjs.push({key: "platformVersion", value: this.projectDetails.platformVersion});
        this.metadataObjs = this.artifactPublishDetails.metadataObjs = metadataObjs;
      }, (err) => {
        this.notificationService.show('error', 'ERROR', err.error.errors.error[0].message);
      });

    }
  }

  setDependencies() {
    if (this.artifactType === "PREFAB" || this.artifactType === "PROJECTSHELL") {
      if (!this.dependencies.length) {
        this.processing = true;
        this.artifactService.getDependencies(this.projectDetails.id, this.artifactType).then((dependencies: any) => {
          this.dependencies = dependencies;
        }, (error: any) => {
          this.processing = false;
          this.notificationService.show('error', 'ERROR', error.error.errors.error[0].message);
        });
      }
    }
  }


  showArtifactDetails() {
    if (!this.isNewArtifactObj && !Object.keys(this.artifactObj).length) {
      if (this.artifactType === "THEME") {
        this.getCurrentThemeDetails();
      } else {
        this.getArtifactDetails();
      }
    }
  }

  getCurrentThemeDetails() {
    this.processing = true;

    this.themeService.listInProject().then((themesList) => {
      this.currentThemeObj = themesList[0];
      this.steps[0]['description'] = replace(this.locale.LABEL_ARTIFACT_PUBLISH_INFO_DESCRIPTION, [(this.currentThemeObj.displayName ? this.currentThemeObj.displayName : this.currentThemeObj.name)]);
      this.getArtifactDetails();
    }, () => {
      this.processing = false;
    })
  }

  getArtifactName() {
    return this.artifactType !== 'THEME' ? this.projectService.projectEdnDetails.name : this.currentThemeObj.name;
  }

  getArtifactDetails(reloadProject?: any) {
    this.processing = true;
    this.artifactService.getArtifact(this.getArtifactName(), this.artifactType, this.projectService.projectEdnDetails.vcsBranch).then((artifactObj) => {
      this.artifactObj = artifactObj;
      this.setArtifactPublishDetails();
      this.processing = false;
    }, (error: any) => {
      if (error && error.status === 500 && error.error.errors.error[0].messageKey === "ARTIFACT_NOT_FOUND_BY_PROJECT_ID_AND_TYPE") {
        this.isNewArtifactObj = true;
        this.setArtifactPublishDetails();
      } else if (error && error.status === 500 && error.error.errors.error[0].messageKey === "ARTIFACT_ALREADY_IN_DRAFT_STATE") {
        this.showArtifactDraftAlert();
      } else {
        this.notificationService.show('error', 'ERROR', error.message);
      }
      this.processing = false;
    });
  }

  showArtifactDraftAlert() {
    this.draftAlert = true;
  }

  async getArtifactCategories() {
    if (!this.categories.length || this.artifactPublishDetails.newCategory) {
      this.processing = true;
      await this.artifactService.getCategories().then((categoryObjs: any) => {
        this.categories = [];
        forEach(categoryObjs, (catObj, i) => {
          this.categories.push(catObj.name)
        });
        //get the artifact details
        triggerFn(this.showArtifactDetails())
      }, (err: any) => {
        this.processing = false;
        this.notificationService.show('error', 'ERROR', err.error.errors.error[0].message);
      })
    }
  }


  getArtifactVersion() {
    return this.artifactType !== "THEME"
      ? get(this.artifactObj, 'artifactVO.version', '0.0.0')
      : (this.isNewArtifactObj
        ? ((parseFloat(this.currentThemeObj.version) - 1).toFixed(1).toString()) // using fixed to convert it into float format "0.0" in order to get the minor version
        : get(this.artifactObj, 'artifactVO.version', '0.0.0'));
  }

  setProjectObj() {
    this.projectObj = {
      "sourceProjectId": this.isNewArtifactObj ? this.projectService.projectEdnDetails.projectId : this.artifactObj.artifactVO.sourceProjectId,
      'name': this.isNewArtifactObj ? (this.artifactType === "THEME" ? this.currentThemeObj.name : this.projectDetails.name) : this.artifactObj.artifactVO.name,
      'displayName': this.isNewArtifactObj ? (this.artifactType === "THEME" ? (this.currentThemeObj.displayName ? this.currentThemeObj.displayName : this.currentThemeObj.name) : this.projectDetails.displayName) : this.artifactObj.artifactVO.displayName,
      'artifactType': this.isNewArtifactObj ? this.artifactType : this.artifactObj.artifactVO.artifactType,
      'description': this.artifactType === "THEME" ? this.currentThemeObj.description : this.projectDetails.description, //Fix for WMS-25931: Always use the project description for description field in publish artifact dialog
      'icon': this.artifactType === "THEME" ? this.currentThemeObj.icon.replace(/:projectId/ig, this.projectDetails.id) : this.projectDetails.icon,
      'categories': this.categories
    };
  }

  assignAvatarPath(icon: any) {
    return this.baseURL + "/images/provatars/" + (icon || 'default.png');
  }

  addToSuggestedVers(version: string) {
    this.suggestedVersions.push({
      version: version,
      category: this.locale.LABEL_SUGGESTED_VERSIONS
    });
  }

  populateSuggestedVersions(currentVersion: string) {
    if (get(this.artifactObj, 'artifactVO.status') === 'DRAFT') {
      this.addToSuggestedVers(currentVersion);
    } else {
      this.addToSuggestedVers(semver.inc(currentVersion, 'patch'));
      this.addToSuggestedVers(semver.inc(currentVersion, 'minor'));
      this.addToSuggestedVers(semver.inc(currentVersion, 'major'));
      this.suggestedVersions = uniqBy(this.suggestedVersions, 'version');
    }
  }

  setArtifactPublishDetails() {
    this.setProjectObj();
    let artifactVer = this.getArtifactVersion(), artifactCategory = get(this.artifactObj, 'artifactVO.category', "");
    let displayName = get(this.projectObj, 'displayName')
    let artifactVersionParts = artifactVer.split(".");
    if (!artifactVersionParts[2]) {
      artifactVersionParts[2] = '0';
    };
    this.currentVersion = artifactVersionParts.join('.');
    this.populateSuggestedVersions(this.currentVersion);
    this.steps[0]['description'] = replace(this.locale.LABEL_ARTIFACT_PUBLISH_INFO_DESCRIPTION, [displayName]);
    this.artifactPublishDetails = {
      "isNew": this.isNewArtifactObj,
      // if the artifact is present in the Team, we use thepreject id from the artifact response for all artifact types like prefab, templatebundle and project shell
      // in case of themes, it is not associated with any project. so the respponse resturned by Team will contain null value.
      // so everytime you publish a theme, send the current project id from which you are publishing. This project id used to read the theme content.
      "sourceProjectId": this.artifactType === "THEME" ? this.projectService.projectEdnDetails.projectId : get(this.projectObj, 'sourceProjectId'),
      "artifactType": this.artifactType,
      "displayName": get(this.projectObj, 'displayName'),
      'name': get(this.projectObj, 'name'),
      'categories': get(this.projectObj, 'categories', []),
      'icon': get(this.projectObj, 'artifactType') !== 'PREFAB' ? this.assignAvatarPath(get(this.projectObj, 'icon')) : '',
      'description': get(this.projectObj, 'description', ""),
      'isValid': true,
      'tags': get(this.artifactObj, 'artifactVO.tags', []) === null ? [] : get(this.artifactObj, 'artifactVO.tags', []),
      'dependencies': get(this.artifactObj, 'dependencies', []),
      'metadataObjs': get(this.artifactObj, 'artifactMetadata', []),
      'isDraft': get(this.artifactObj, 'artifactVO.status') === 'DRAFT',
      'category': includes(this.categories, artifactCategory) ? artifactCategory : "",
      'query': artifactCategory || "",
      'newCategory': "",
      'commitMsg': this.isNewArtifactObj ? "" : (get(this.artifactObj, 'artifactVO.status', 'PUBLISHED') === "DRAFT" ? get(this.artifactObj, 'artifactVO.publisherComments', "") : ""),
      'version': artifactVer,
      'currentVersion'     : this.currentVersion,
      'newVersion'         : get(this.artifactObj, 'artifactVO.status') === 'DRAFT' ? this.suggestedVersions[0]?.version : "",
      'suggestedVersions'  : this.suggestedVersions,
    };

    if (this.artifactType === 'PREFAB') {
      this.setPrefabIcon();
    }
    if (this.artifactType === 'THEME') {
      this.setThemeIcon();
    }
  }

   setPrefabIcon() {
  //   //this is an async op. Will take time to show up in the UI
  //   PrefabManager.getConfig(function (config) {
  //     $s.artifactPublishDetails.icon = config.iconUrl;
  //     //replace the special characters except / .  - with _
  //     var url = Utils.getProjectResourcePath($rs.project.id) + config.iconUrl.replace(/[^A-Z0-9\/\.\-]/ig, "_");
  //     $s.artifactPublishDetails.icon = Utils.removeExtraSlashes(url);
  //   }, function (error) {
  //     wmToaster.show('error', $rs.locale.MESSAGE_ERROR_TITLE, $rs.locale.MESSAGE_ERROR_PREFAB_PROPS_READ);
  //   }, true);
  }

  setThemeIcon() {
    this.artifactPublishDetails.icon = location.origin + '/studio/' + this.currentThemeObj.icon.replace(/:projectId/ig, this.projectDetails.id);
  }


  updateNextBtnText() {
    this.nextBtnText = this.isFinalStep() ? this.locale.LABEL_TEMPLATE_PROPS_PUBLISH : this.locale.LABEL_NEXT;
  }

  validateCurrentStep(): any {
    if (this.curStep.id === 'artifact-publish-info' && this.artifactPublishDetails) {
      return !this.artifactPublishDetails.isValid || !this.artifactPublishDetails.commitMsg || !this.artifactPublishDetails.category || !this.artifactPublishDetails.query || !this.artifactPublishDetails.newVersion
    }
    return false;
  }

  publishToTeam() {
    this.processing = true;
    this.publishChangesToTeam();
  }

  getStepTemplate():any{
    switch (this.curStep?.id) {
      case 'artifact-config': return this.configurationScreen;
      case 'artifact-publish-info': return this.informationScreen;
      case 'artifact-summary': return this.summaryScreen;
    }
  }

  publishChangesToTeam() {
    this.showErrMsg = false;
    let payload: any = {
      "sourceProjectId": this.projectService.projectEdnDetails.projectId,
      "name": this.artifactPublishDetails.name,
      "version": this.artifactPublishDetails.newVersion,
      "category": this.artifactPublishDetails.category,
      "description": this.artifactPublishDetails.description,
      "publisherComments": this.artifactPublishDetails.commitMsg,
      "tags": this.artifactPublishDetails.tags,
      "artifactType": this.artifactPublishDetails.artifactType,
      "displayName": this.artifactPublishDetails.displayName,
      "dependencies": this.dependencies,
      //"artifactMetadataList": $s.artifactPublishDetails.metadataObjs
      "artifactMetadataList": []
    };
    if (this.artifactPublishDetails.artifactType === "PROJECTSHELL") {
      payload['artifactMetadataList'].push({
        'name': 'type',
        'value': this.projectDetails.type,
        'metadataType': 'ARTIFACT'
      });
      payload['artifactMetadataList'].push({
        'name': 'platformType',
        'value': this.projectDetails.platformType,
        'metadataType': 'ARTIFACT'
      });
    }
    if (this.artifactPublishDetails.artifactType === "TEMPLATEBUNDLE" || this.artifactPublishDetails.artifactType === "THEME") {
      payload['artifactMetadataList'].push({
        'name': 'platformType',
        'value': this.artifactPublishDetails.artifactType === "THEME" ? this.currentThemeObj.platformType : this.projectDetails.platformType,
        'metadataType': 'ARTIFACT'
      });
    }

    this.artifactService.publishToTeam(payload).then(() => {
      this.publishTeamSuccessHandler()
    }, (err) => {
      this.publishTeamErrorHandler(err.error.errors.error[0].message)
    });

  }


  publishTeamSuccessHandler() {
    let msg = this.locale.LABEL_ARTIFACT_SUCCESS_MESSAGE_TEAM;
    this.successMessage = replace(msg, [upperFirst(camelCase(this.artifactPublishDetails.artifactType))]);
    this.isPublishSuccessful = true;
    this.artifactPublishDetails.isValid = false;
    this.processing = false;
  }

  publishTeamErrorHandler(errMsg: any) {
    this.showErrMsg = true;
    this.errorMsg(errMsg);
    this.processing = false;
  }

  incrementStep() {
    if (this.isFinalStep()) {
      this.publishToTeam();
    } else {
      this.stepCounter += 1;
      this.curStep = this.steps[this.stepCounter];
      this.onStepChange(this.stepCounter, false);
    }

  }

  isFinalStep(): any {
    return this.stepCounter === (this.steps.length - 1);
  }

  closePublishDialog(): any {
    this.dialogService.close('publishArtifactToTeam')
  }

  addTag() {
    let tag = this.artifactPublishDetails.tag;
    this.artifactPublishDetails.tag = "";
    if (tag && !this.isTagPresent(tag) && tag !== "") {
      this.artifactPublishDetails.tags.push(tag);
    }
  };

  isTagPresent(tag: any) {
    let isTagPresent = some(this.artifactPublishDetails.tags, function (existingTag) {
      return existingTag.toLowerCase() === tag.toLowerCase();
    });
    return isTagPresent;
  }

  addNewArtifactCategory() {
    let data = {
      "name": this.artifactPublishDetails.newCategory
    };
    var categoryList = map(this.categories, toLower) || [];
    if (this.artifactPublishDetails.newCategory.length && categoryList.indexOf(this.artifactPublishDetails.newCategory.toLowerCase()) == -1) {
      this.processing = true;

      this.artifactService.setCategory(data).then((responce) => {
          this.getArtifactCategories();
          this.artifactPublishDetails.query = this.artifactPublishDetails.newCategory;
          this.artifactPublishDetails.category = this.artifactPublishDetails.newCategory;
          this.artifactPublishDetails.categories = this.categories;
          this.showCategoriesList = false;
          this.artifactPublishDetails.newCategory = "";
          this.processing = false;
        },
        (errorObj) => {
          this.processing = false;
          this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, errorObj);

        });
    } else {
      this.processing = false;
      // category already exists
      this.notificationService.show('info', this.locale.MESSAGE_INFO_TITLE, replace(this.locale.LABEL_ARTIFACT_CATEGORY_EXISTS, [this.artifactPublishDetails.newCategory]));
      this.artifactPublishDetails.newCategory = "";
    }

  }

  errorMsg(msg:any){
    this.errMsg = {
      type: 'error',
      caption: msg
    };
  }


  protected readonly undefined = undefined;
}
